/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentPage } from 'state/slices/app';
import { setTempProductManagerConfig } from 'state/slices/productmanager';
// material
import Space from 'material/space/space';
import { Switch, Tip, CopySnippetField, Icon, ToolTip } from '@insticator/insticator-ui';
import { SectionGroupV2 } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './additional_styles'
import { useNavigation } from 'utils/navigation';

const commentsCounterCode = `<a href="{pageUrl}#insticator-commenting" data-page-id="{pageId}"></a>`

/* ========== ~~~~~~~~~~ PRODUCT MANAGER: SITE SETUP : ADDITIONAL ~~~~~~~~~~ ========== */
const Additional = injectSheet(styles)((props) => {

  const dispatch = useDispatch()
  const { tempProductManagerConfig: { commentsCounterEnabled }, tempProductManagerConfig }  = useSelector(state => state.productManager)

  const handleCommentsCounterChange = useCallback((value) => {
    const newConfig = {
      ...tempProductManagerConfig,
      commentsCounterEnabled: value
    }
    dispatch(setTempProductManagerConfig({config: newConfig, changes: 'commentsCounterEnabled'}))
}, [dispatch, tempProductManagerConfig]);

  const { handleNavigation } = useNavigation()
  
  const handleSettingsNavigation = () =>  handleNavigation('/dashboard/commenting/configuration?view=commentsCounter')

  return (
    <SectionGroupV2 
      klass={`additional ${props.classes.additional}`} 
      title={'Additional'} 
      description={'Select any additional feature needs for a given site.'}
      direction={'column'}
    >
      <Space gap={6}>
        <Switch on={commentsCounterEnabled} handleClick={()=> handleCommentsCounterChange(!commentsCounterEnabled)} variant={'primary'} />
        <label>Comments counter{' '}
          <ToolTip
            position={'top'}
            trigger={'mouseenter focus'}
            content={'Configure settings'}
          >
            <Icon name={'cog'} handleClick={handleSettingsNavigation} />
          </ToolTip>
        </label>
        <Tip 
          space={'none'} 
          icon={'question-circle'} 
          label={''} 
          content={`
            Place this code directly into the <body> element of your page where you want the comments counter to show. 
            For example, on an article preview snapshot on your home page, or beneath the page title on the article itself. 
            This will display the number of comments an article contains.
          `} 
        />
      </Space>
      {!!commentsCounterEnabled ?
        <CopySnippetField
          codeSnippet={commentsCounterCode}
          inline
        />
      :
      <div style={{height: '56px'}} />
      }
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Additional;